<template>
  <section class="mt-40">
    <b-tabs v-model="activeTab" multiline>
      <b-tab-item
        v-for="(item, i) in items" :key="i"
        :label="$t(item.label)">
        <component 
          :is="item.component"
          :client-id="item.component === 'ListeRecom' ? $route.params.id : null"
          :client-type="item.component === 'ListeRecom' ? $route.params.type : null"
          :societe-id="item.component === 'ListeRecom' ? societeId : null"/>
      </b-tab-item>
    </b-tabs>
  </section>
</template>
<script>
import ListesPJ from './listesPJ';
import listeClientInferieur from './listeClientInferieur';
import ListesContacts from './listesContact';
import ListeRecom from '@/components/tableauDeBord/ListeRecom.vue';
import * as config from '@/configuration/clientConf';

export default {
  components: {
    listeClientInferieur,
    ListesContacts,
    ListesPJ,
    ListeRecom
  },
  props: {
    societeId: {
      type: String,
      default: null
    }
  },
  data:() => ({
    activeTab: 0,
    config,
  }),
  computed: {
    type() {
      return this.$route.params.type;
    },
    items() {
      return [
      {
        label: this.libelleOngletClientsInferieur,
        component: 'listeClientInferieur',
        affiche: this.type !== config.POINT_VENTE ,
      },
      {
        label: 'detailClient.ongletBudget.titleOnglet',
        component: '',
        affiche: false,
      },
      {
        label: 'detailClient.ongletRecom.titleOnglet',
        component: 'ListeRecom',
        affiche: true,
      },
      {
        label: 'detailClient.ongletContacts.titleOnglet',
        component: 'ListesContacts',
        affiche: true,
      },
      {
        label: 'detailClient.ongletCartographie.titleOnglet',
        component: '',
        affiche: false,
      },
      {
        label: 'detailClient.ongletPJ.titleOnglet',
        component: 'ListesPJ',
        affiche: true,
      },
    ].filter(el => el.affiche);
    },
    libelleOngletClientsInferieur() {
      const type = this.$route.params.type;
      if (type === config.ENSEIGNE) return 'detailClient.ongletEnseiqgnepDV.titleOngletEnseigne';
      return 'detailClient.ongletEnseiqgnepDV.titleOnglet';
    },
  }
}
</script>
<style>
</style>